import React from 'react'
import { useLocation } from 'react-router-dom'

import SiteReveal from '@components/SiteSurprise/SiteReveal'
import GeneratedSiteWaiting from '@components/SiteSurprise/GeneratedSiteWaiting'
import {
  useMyGeneratedSite,
  useMarkGeneratedSiteViewed,
  isGeneratedSiteInProgress,
} from '@hooks/queries/generated-site'

// espace client : le site internet « surprise » (aperçu, activation, modifications par prompt)
const SiteInternetPage = () => {
  const location = useLocation()
  // ?offer=1 : lien « Garder mon site » des emails et de la page publique, l'offre s'ouvre tout de suite
  const params = new URLSearchParams(location.search)
  const autoOpenOffer = params.get('offer') === '1'
  // &pub=1 : « Je veux lancer cette publicité » cliqué sur la page publique avant connexion
  const autoAdInterest = params.get('pub') === '1'
  const siteQuery = useMyGeneratedSite()
  const markViewed = useMarkGeneratedSiteViewed()
  const site = siteQuery.data

  React.useEffect(() => {
    if (site?.status === 'READY' && !site.viewedAt && !markViewed.isPending) markViewed.mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?.status])

  if (siteQuery.isPending) return null

  if (!site || siteQuery.isError || ['FAILED', 'DELETED'].includes(site.status)) {
    return (
      <div className="connexion-container rounded-2xl text-center">
        <h1 className="[&&&]:text-2xl font-semibold mb-2">Votre site internet</h1>
        <p className="text-new-dark-gray text-sm">
          {site?.generationRefused
            ? 'Nous n’avons pas pu créer votre site à partir de votre description (contenu non pris en charge). Écrivez-nous depuis la rubrique Aide pour en parler.'
            : 'Aucun site n’est disponible pour le moment. Envie d’un site vitrine pour votre activité ? Écrivez-nous depuis la rubrique Aide.'}
        </p>
      </div>
    )
  }

  if (site.unpublishedAt) {
    return (
      <div className="connexion-container rounded-2xl text-center">
        <h1 className="[&&&]:text-2xl font-semibold mb-2">Votre site internet</h1>
        <p className="text-new-dark-gray text-sm">
          {`Votre site n’est plus en ligne depuis le ${new Date(site.unpublishedAt).toLocaleDateString('fr-FR')}. `}
          Pour le remettre en ligne, écrivez-nous depuis la rubrique Aide.
        </p>
      </div>
    )
  }

  if (isGeneratedSiteInProgress(site) && !site.previewUrl) {
    return (
      <div className="max-w-[760px] mx-auto">
        <GeneratedSiteWaiting startedAt={site.generationStartedAt || site.createdAt} onContinue={() => {}} timedOut={false} />
      </div>
    )
  }

  return (
    <div className="max-w-[1120px] mx-auto">
      <SiteReveal site={site} withIntro={false} withDomain autoOpenOffer={autoOpenOffer} autoAdInterest={autoAdInterest} />
    </div>
  )
}

export default SiteInternetPage
